/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: 6Cb3e8nRgrBg

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicChatMessage.module.css"; // plasmic-import: 6Cb3e8nRgrBg/css

createPlasmicElementProxy;

export type PlasmicChatMessage__VariantMembers = {
  type: "user" | "assistant";
};
export type PlasmicChatMessage__VariantsArgs = {
  type?: SingleChoiceArg<"user" | "assistant">;
};
type VariantPropType = keyof PlasmicChatMessage__VariantsArgs;
export const PlasmicChatMessage__VariantProps = new Array<VariantPropType>(
  "type"
);

export type PlasmicChatMessage__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicChatMessage__ArgsType;
export const PlasmicChatMessage__ArgProps = new Array<ArgPropType>("children");

export type PlasmicChatMessage__OverridesType = {
  row?: Flex__<"div">;
  message?: Flex__<"div">;
};

export interface DefaultChatMessageProps {
  children?: React.ReactNode;
  type?: SingleChoiceArg<"user" | "assistant">;
  className?: string;
}

const $$ = {};

function PlasmicChatMessage__RenderFunc(props: {
  variants: PlasmicChatMessage__VariantsArgs;
  args: PlasmicChatMessage__ArgsType;
  overrides: PlasmicChatMessage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.type,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"row"}
      data-plasmic-override={overrides.row}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.row,
        {
          [sty.rowtype_assistant]: hasVariant($state, "type", "assistant"),
          [sty.rowtype_user]: hasVariant($state, "type", "user"),
        }
      )}
    >
      <div
        data-plasmic-name={"message"}
        data-plasmic-override={overrides.message}
        className={classNames("all", sty.message, {
          [sty.messagetype_assistant]: hasVariant($state, "type", "assistant"),
          [sty.messagetype_user]: hasVariant($state, "type", "user"),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div className={classNames("all", "__wab_text", sty.text__eCdm)}>
              {
                "Sure!\nThis feature helps you understand what\u2019s happening at each step. It gives you clear feedback, highlights important actions, and makes it easier to move forward without getting stuck."
              }
            </div>
          ),
          value: args.children,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  row: ["row", "message"],
  message: ["message"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  row: "div";
  message: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicChatMessage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicChatMessage__VariantsArgs;
    args?: PlasmicChatMessage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicChatMessage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicChatMessage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicChatMessage__ArgProps,
          internalVariantPropNames: PlasmicChatMessage__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicChatMessage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "row") {
    func.displayName = "PlasmicChatMessage";
  } else {
    func.displayName = `PlasmicChatMessage.${nodeName}`;
  }
  return func;
}

export const PlasmicChatMessage = Object.assign(
  // Top-level PlasmicChatMessage renders the root element
  makeNodeComponent("row"),
  {
    // Helper components rendering sub-elements
    message: makeNodeComponent("message"),

    // Metadata about props expected for PlasmicChatMessage
    internalVariantProps: PlasmicChatMessage__VariantProps,
    internalArgProps: PlasmicChatMessage__ArgProps,
  }
);

export default PlasmicChatMessage;
/* prettier-ignore-end */
